import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GenericModalComponent } from '../../generic-modal/generic-modal.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HelpService } from 'src/app/services/help.service';
import { ToastService } from 'src/app/services/ui/toast.service';
import { ToastType } from '../../toast/models/toast-type.enum';

@Component({
	selector: 'app-help-request-modal',
	templateUrl: './help-request-modal.component.html',
	styleUrls: [
		'../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss',
		'../../stylesheets/job-inputs.scss', '../../stylesheets/job-contacts.scss',
		'./help-request-modal.component.scss'
	]
})
export class HelpRequestModalComponent implements OnInit, OnDestroy {
	public photoTypes = ".jpg, .png, .gif, .tiff, .tif, .bmp, .jpeg"
	
	@ViewChild('helpSupportModal') public helpSupportModal: GenericModalComponent;
	_isVisible: boolean;
	get isVisible(): boolean {
		return this._isVisible;
	}
	@Input() set isVisible(value: boolean) {
		this._isVisible = value;
		this.triggerModalVisibility();
	}
	@Output() onToggleVisibility: EventEmitter<boolean> = new EventEmitter();
	@Input() public sites = [];
	public isMaxAllowedPhoto = false;
	public maxAllowedPhotos = 10;
	public hashToken = '';
	public isSaving = false;
	private unsubscriber$: Subject<void> = new Subject<void>();
	private DefaultIssueTypeId = 27;
	public helpRequestForm = this.formBuilder.group({
		accountSiteId: ['', Validators.required],
		issueTypeId: [this.DefaultIssueTypeId, Validators.required],
		issue: ['', Validators.required],
		issueDetails: ['', Validators.required],
		photos: [[]]
	});

	constructor(
		private formBuilder: FormBuilder,
		private helpService: HelpService,
	) { }

	ngOnInit(): void { }

	public onClose() {
		this.helpRequestForm.reset();
		this.helpRequestForm.patchValue({
			photos: [],
			accountSiteId: '',
			issueTypeId: this.DefaultIssueTypeId,
			issue: '',
			issueDetails: ''
		});
		this.hashToken = '';
		this.isMaxAllowedPhoto = false;
		this.onToggleVisibility.emit(!this._isVisible);
	}

	public onPhotoChange(event, photosInput) {
		const fileList = Object.values(event.target.files) as any[];

		if (fileList.length <= this.maxAllowedPhotos) {
			const existingPhotos = this.helpRequestForm.get('photos').value;

			if (existingPhotos.length + fileList.length <= this.maxAllowedPhotos) {

				this.isMaxAllowedPhoto = false;
				let lastId = existingPhotos.length > 0 ? Math.max(...existingPhotos.map(f => f.localId)) : 0;
				lastId++;
				fileList.forEach((x, index) => x.localId = lastId + index)

				this.helpRequestForm.patchValue({ photos: existingPhotos.concat(fileList) });
			}
			else {
				this.isMaxAllowedPhoto = true;
			}
		}
		else {
			this.isMaxAllowedPhoto = true;
		}

		photosInput.value = '';
	}

	public onDeletePhoto(photo) {
		const existingPhotos = this.helpRequestForm.get('photos').value;
		const photos = existingPhotos.filter(x => x.localId !== photo.localId);
		this.helpRequestForm.patchValue({ photos });
		this.isMaxAllowedPhoto = false;
	}

	public onSave() {
		const requestForm = new FormData();
		
		const p = document.createElement("p");
		p.textContent = this.helpRequestForm.get("issueDetails").value;
		const issueDetailsEncode = p.innerHTML;
		
		requestForm.append("accountSiteId", this.helpRequestForm.get("accountSiteId").value);
		requestForm.append("issueTypeId", this.DefaultIssueTypeId.toString());
		requestForm.append("issue", this.helpRequestForm.get("issue").value);
		requestForm.append("issueDetails", issueDetailsEncode);
		const photos = this.helpRequestForm.get("photos").value;
		photos.forEach(x => {
			requestForm.append('photo[]', x)
		})

		this.isSaving = true;
		this.helpService
			.saveHelpRequest(this.hashToken, requestForm)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe(
				result => {
					this.isSaving = false;
					if (result.isRequestSuccess && !!result.helpRequestId) {
						this.onClose();
					}
					else {
						ToastService.pushToast({
							text: 'Could not submit the help request. Please try again!',
							icon: 'error',
							type: ToastType.Error
						});
					}
					
				},
				() => {
					ToastService.pushToast({
						text: 'Could not submit the help request. Please try again!',
						icon: 'error',
						type: ToastType.Error
					});
					this.isSaving = false;
				}
			)
	}

	private triggerModalVisibility() {
		if (this._isVisible) {
			this.helpSupportModal?.open();
			this.hashToken = window.location.pathname.split('/')[1]
		}
		else {
			this.helpSupportModal?.hide();
		}
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}
}
